export interface SalesDespatchNotesCreated {
  id: string;
  despatchNoteNo: number;
  despatchDate: Date;
  createdBy: string;
  customerKey: string;
  customerName: string;
  deliveryAddress: string;
  shipperSupplier: string;
  trackingNo: string;
  salesDespatchNoteStatus: string;
  deliveryAddressee: string;
}
